import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/DashboardTile.css'; // Adjust the path as necessary

const DashboardTile = ({ path, label, className }) => {
  return (
    <Link to={path} className={`dashboard-tile ${className}`}>
    </Link>
  );
};

export default DashboardTile;